import React from 'react'
import { tokens } from '../../../styles/desertFloraTheme'
import ValidationPanel from './ValidationPanel'
import CostBreakdownPanel from './CostBreakdownPanel'
import AreasPanel from './AreasPanel'
import MarkupDefaultsPanel from './MarkupDefaultsPanel'

const RightRail = ({ projectService, projectServices, project }) => {
  return (
    <div style={{
      overflow: 'auto', padding: 20,
      background: tokens.surface,
      borderLeft: `1px solid ${tokens.line}`,
      height: '100%', boxSizing: 'border-box'
    }}>
      {projectService ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 22 }}>
          <ValidationPanel
            projectService={projectService}
            projectServices={projectServices}
          />
          <CostBreakdownPanel projectService={projectService} />
          <AreasPanel projectService={projectService} />
          <MarkupDefaultsPanel project={project} />
        </div>
      ) : (
        <div style={{ fontSize: 13, color: tokens.ink4, paddingTop: 20 }}>
          Select a service to see details
        </div>
      )}
    </div>
  )
}

export default RightRail
